import firebase from 'firebase/app'
import 'firebase/auth'

const waitForLogin = ((callback) => {
    console.log('login.js->waitForLogin->waiting for user')
    firebase.auth().onAuthStateChanged(callback);
})

const emailSignIn = ((email, password) => {
    console.log('signing a user in', email)
    return firebase.auth().signInWithEmailAndPassword(email, password)
})
const createUser = ((email, password) => {
    return firebase.auth().createUserWithEmailAndPassword(email, password)
})

const signOut = () => {
    return firebase.auth().signOut()
}

export default {
    emailSignIn,
    waitForLogin,
    createUser,
    signOut
}